angular.module('autoremind.users')
    .directive('adminUserBillingSettings', ['accountService', 'userProfile', 'logger', 'chargifyService',
    function (accountService, userProfile, logger, chargifyService) {
        return {
            restrict: 'E',
            templateUrl: 'app/admin/users/admin-user-billing-settings.html',
            scope: {
                viewModel: '=model'
            },
            link: function (scope, element, attrs) {
                userProfile.initalizeViewModel();
                if (userProfile.viewModel.views.admin === undefined) {
                    // This is the first time opening the view, so initialize
                    userProfile.viewModel.views.admin = {};
                }
                if (userProfile.viewModel.views.admin.chargify === undefined) {
                    // This is the first time opening the view, so initialize
                    userProfile.viewModel.views.admin.chargify = {};
                }
                scope.viewModel.loadingIndicator = { 'state': false, 'refCount': 0 };
                scope.viewModel.selectedUser = null;
                scope.accountFind = "";
                scope.products = [];
                scope.editAccountList = [];
                scope.isDataLoadStarted = false;
                // Setup watcher to load data the first time the tab is viewed (even if by route rather than click on tab)
                if (angular.isDefined(scope.viewModel.activeTabIndex)) {
                    scope.$watch('viewModel.activeTabIndex', function (newTabIndex, oldTabIndex) {
                        if (angular.isDefined(newTabIndex) && !scope.isDataLoadStarted && !scope.editAccountListStateBusy &&
                            newTabIndex === scope.viewModel.tabIndexes['billingSettings']) {
                            scope.isDataLoadStarted = true;
                            scope.getSelectedUserData();
                        }
                    });
                }
                scope.changed = function (account) {
                    account.changed = true;
                };
                scope.updateFormToZohoBillingAddress = function (account) {
                    if (account.customer == null) {
                        account.customer = {};
                    }
                    account.customer.organization = account.zohoCustomer.Account_Name;
                    account.customer.reference = account.userName;
                    account.customer.address = account.zohoCustomer.Billing_Street;
                    account.customer.address_2 = "";
                    account.customer.city = account.zohoCustomer.Billing_City;
                    account.customer.state = account.zohoCustomer.Billing_State;
                    account.customer.zip = account.zohoCustomer.Billing_Code;
                    account.customer.country = account.zohoCustomer.Billing_Country;
                    account.customer.phone = account.zohoCustomer.Phone; // TODO: Remove non-digit characters
                    account.customer.email = ""; // TODO: Add alert with the email that was deleted (if any was defined before)
                    account.customer.first_name = ""; // TODO: Add alert with the name that was deleted (if any was defined before)
                    account.customer.last_name = ""; // TODO: Add alert with the name that was deleted (if any was defined before)
                    account.changed = true;
                };
                scope.fetchProductList = function () {
                    logger.debug('autoremind.admin.chargify.ScreenController.fetchProductList() start');
                    chargifyService.fetchProductList()
                        .then(function (data, status) {
                        scope.products = data.chargifyProducts;
                    }, function (data, status) {
                        scope.status = status;
                    });
                    logger.debug('autoremind.admin.chargify.ScreenController.fetchProductList() end');
                };
                scope.accountIsChanged = function (userName) {
                    var isChanged = false;
                    for (var i = 0; i < scope.editAccountList.length; i++) {
                        if (scope.editAccountList[i].userName === userName) {
                            isChanged = scope.editAccountList[i].changed;
                            // TODO: Should we break here so isChanged=true will not be reset by later items?
                        }
                    }
                    return isChanged;
                };
                /**
                 * Request the backend for users matching the search pattern - typically used for type-ahead functionality.
                 */
                scope.searchUsersList = function (pattern) {
                    scope.viewModel.selectedUser = null; // None selected, so user details should be hidden
                    // NOTE: selectedUser will be added/changed on viewModel provided/used by parent
                    //scope.viewModel.detailsVisible = false;
                    return accountService.searchUser(pattern, scope.viewModel.loadingIndicator)
                        .then(function (users) {
                        return scope.viewModel.usersList = users;
                        // NOTE: usersList will be added/changed on viewModel provided/used by parent
                    });
                };
                /**
                 * Output displayed by the type-ahead patient search field
                 */
                scope.userFormatInput = function (model) {
                    if (model === null || !angular.isDefined(model)) {
                        return '';
                    }
                    return model.name;
                };
                scope.fetchAccount = function (userName) {
                    logger.debug('autoremind.admin.chargify.ScreenController.fetchAccount(' + userName + ') start');
                    scope.editAccountListStateBusy = true;
                    for (var j = 0; j < scope.editAccountList.length; j++) {
                        scope.editAccountList[j].show = false;
                    }
                    if (scope.products.length == 0) {
                        scope.fetchProductList();
                        // TODO: Find a way to chain on the promise to ensure that we know exactly when all data loaded
                    }
                    if (!scope.accountIsChanged(userName)) {
                        chargifyService.fetchAccount(userName)
                            .then(function (data, status) {
                            if (data.account != null && data.account.userName != null) {
                                if (data.account.subscription != null
                                    && data.account.subscription.product != null
                                    && data.account.subscription.product.product_family != null
                                    && data.account.subscription.product.product_family.handle != null) {
                                    data.account.producthandle = data.account.subscription.product.product_family.handle;
                                }
                                var isUpdated = false;
                                for (var i = 0; i < scope.editAccountList.length; i++) {
                                    if (scope.editAccountList[i].userName === data.account.userName) {
                                        if (!scope.editAccountList[i].changed) {
                                            scope.findHasOwnSubscription(data.account);
                                            scope.editAccountList[i] = data.account;
                                        }
                                        scope.editAccountList[i].show = true;
                                        isUpdated = true;
                                    }
                                    else {
                                        scope.editAccountList[i].show = false;
                                    }
                                }
                                if (!isUpdated) {
                                    data.account.changed = false;
                                    data.account.show = true;
                                    scope.findHasOwnSubscription(data.account);
                                    scope.editAccountList.push(data.account);
                                }
                            }
                            scope.editAccountListStateBusy = false;
                        }, function (data, status) {
                            scope.status = status;
                        });
                    }
                    else {
                        for (var i = 0; i < scope.editAccountList.length; i++) {
                            scope.editAccountList[i].show =
                                scope.editAccountList[i].userName === userName;
                        }
                        scope.editAccountListStateBusy = false;
                    }
                    logger.debug('autoremind.admin.chargify.ScreenController.fetchAccount(' + userName + ') end');
                };
                scope.getSelectedUserData = function () {
                    if (!angular.isDefined(scope.viewModel.selectedUserInfo) && scope.viewModel.selectedUserInfo === null) {
                        return;
                    }
                    //$location.search('userid', scope.viewModel.selectedUser.userId);
                    scope.fetchAccount(scope.viewModel.selectedUserInfo.userName);
                };
                scope.getMonth = function (displacementMonths) {
                    var date = new Date();
                    date.setMonth(date.getMonth() + displacementMonths);
                    if (date.getMonth() >= 9) {
                        return date.getFullYear() + "-" + (date.getMonth() + 1);
                    }
                    else {
                        return date.getFullYear() + "-0" + (date.getMonth() + 1);
                    }
                };
                scope.findHasOwnSubscription = function (account) {
                    if (account.userPaymentOwnerId != null && account.userPaymentOwnerId > 0) {
                        if (account.userPaymentOwnerId === account.userId) {
                            account.hasOwnSubscription = true;
                            if (account.customer == null) {
                                account.customer = { "reference": account.userName };
                                account.next_billing_at = scope.getMonth(1) + "-01";
                            }
                        }
                        else {
                            account.hasOwnSubscription = false;
                        }
                    }
                    else {
                        account.hasOwnSubscription = null;
                    }
                };
                scope.savePaymentUserName = function (account) {
                    logger.debug('autoremind.admin.chargify.ScreenController.savePaymentUserName(' + account.userName + ',' + account.paymentUserName + ')');
                    account.updateSubscriptionBusy = true;
                    var updateJSON = { "account": { "userId": account.userId, "userName": account.userName, "paymentUserName": account.paymentUserName } };
                    chargifyService.savePaymentUserName(account.userName, updateJSON)
                        .then(function (data, status) {
                        if (data.account != null && data.account.userName != null) {
                            data.account.hasOwnSubscription = false;
                            for (var i = 0; i < scope.editAccountList.length; i++) {
                                if (scope.editAccountList[i].userName === data.account.userName) {
                                    if (data.account.errormsg) {
                                        scope.editAccountList[i].errormsg = data.account.errormsg;
                                    }
                                    else {
                                        scope.editAccountList[i] = data.account;
                                        data.account.changed = false;
                                    }
                                    scope.editAccountList[i].show = true;
                                }
                                else {
                                    scope.editAccountList[i].show = false;
                                }
                                scope.editAccountList[i].updateSubscriptionBusy = false;
                            }
                        }
                    }, function (data, status) {
                        scope.status = status;
                    });
                };
                scope.subscriptionSave = function (account) {
                    logger.debug('autoremind.admin.chargify.ScreenController.subscriptionSave(' + account.userName + ')');
                    account.updateSubscriptionBusy = true;
                    if (account.subscription != null && account.subscription.id != null) {
                        // update existing customer data
                        var updateJSON = { "customer": account.customer };
                        chargifyService.subscriptionSave(account.customer.id, updateJSON)
                            .then(function (data, status) {
                            if (data.customerId) {
                                for (var i = 0; i < scope.editAccountList.length; i++) {
                                    if (data.customerId === scope.editAccountList[i].customer.id) {
                                        if (data.errormsg != null) {
                                            scope.editAccountList[i].errormsg = data.errormsg;
                                            if (data.chargifyErrors != null) {
                                                scope.editAccountList[i].chargifyErrors = data.chargifyErrors;
                                            }
                                        }
                                        if (data.customer && data.customer.id) {
                                            scope.editAccountList[i].customer = data.customer;
                                            scope.editAccountList[i].changed = false;
                                        }
                                        scope.editAccountList[i].show = true;
                                        scope.editAccountList[i].updateSubscriptionBusy = false;
                                    }
                                    else {
                                        scope.editAccountList[i].show = false;
                                    }
                                }
                            }
                        }, function (data, status) {
                            scope.status = status;
                        });
                    }
                    else {
                        // create new customer and subscription
                        updateJSON = { "customer": account.customer, "product_handle": account.producthandle, "next_billing_at": account.next_billing_at };
                        chargifyService.createNewUserAndSubscription(account.userName, updateJSON)
                            .then(function (data, status) {
                            if (data.userName != null && data.userName != null) {
                                if (data.account != null && data.account.subscription != null
                                    && data.account.subscription.product != null
                                    && data.account.subscription.product.product_family != null
                                    && data.account.subscription.product.product_family.handle != null) {
                                    data.account.producthandle = data.account.subscription.product.product_family.handle;
                                }
                                for (var i = 0; i < scope.editAccountList.length; i++) {
                                    if (scope.editAccountList[i].userName === data.userName) {
                                        if (data.errormsg != null) {
                                            scope.editAccountList[i].errormsg = data.errormsg;
                                            if (data.chargifyErrors != null) {
                                                scope.editAccountList[i].chargifyErrors = data.chargifyErrors;
                                            }
                                        }
                                        if (data.account != null && scope.editAccountList[i].userName === data.account.userName) {
                                            scope.findHasOwnSubscription(data.account);
                                            scope.editAccountList[i] = data.account;
                                            scope.editAccountList[i].changed = false;
                                        }
                                        scope.editAccountList[i].show = true;
                                        scope.editAccountList[i].updateSubscriptionBusy = false;
                                    }
                                    else {
                                        scope.editAccountList[i].show = false;
                                    }
                                }
                            }
                        }, function (data, status) {
                            scope.status = status;
                        });
                    }
                };
                scope.fetchZohoBillingAddress = function (account) {
                    logger.debug('autoremind.admin.chargify.ScreenController.fetchZohoBillingAddress() start');
                    account.updateSubscriptionBusy = true;
                    chargifyService.fetchZohoBillingAddress(account.userName)
                        .then(function (data, status) {
                        if (data.customerUserName) {
                            for (var i = 0; i < scope.editAccountList.length; i++) {
                                if (data.customerUserName === scope.editAccountList[i].userName) {
                                    if (data.customer) {
                                        scope.editAccountList[i].zohoCustomer = data.customer;
                                    }
                                    else {
                                        scope.editAccountList[i].zohoError = "No data found in ZOHO";
                                    }
                                    scope.editAccountList[i].updateSubscriptionBusy = false;
                                }
                            }
                        }
                    }, function (data, status) {
                        scope.status = status;
                    });
                    logger.debug('autoremind.admin.chargify.ScreenController.fetchZohoBillingAddress() end');
                };
            }
        };
    }]);
//# sourceMappingURL=admin-user-billing-settings.js.map